var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1949 17.7957C21.2839 13.3312 25.3046 10.9506 25.5973 10.7811C24.9827 9.98639 24.2656 9.38594 23.5412 8.9515C21.1376 7.5069 18.2108 7.36915 16.4693 8.11087C16.451 8.11794 16.4364 8.125 16.4181 8.13207C14.7169 8.84907 12.7888 8.84907 11.0876 8.13207C11.0693 8.125 11.0547 8.11794 11.0364 8.11087C9.29496 7.37268 6.36817 7.5069 3.96453 8.9515C1.56088 10.3961 -0.773254 13.6597 0.412104 19.9149C1.59746 26.1702 5.9145 29.9707 5.9145 29.9707C5.9145 29.9707 7.9706 31.6872 10.6852 30.5429C12.3828 29.8294 13.1547 29.7058 13.4986 29.7128C13.6669 29.7164 13.8352 29.7164 14.0071 29.7128C14.3474 29.7058 15.1193 29.8294 16.8205 30.5429C19.5388 31.6872 21.5912 29.9707 21.5912 29.9707C21.5912 29.9707 24.6168 27.3075 26.2997 22.7688C24.8546 22.126 22.7876 20.7132 22.1949 17.7922V17.7957Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9901 7.87483C12.9901 7.87483 12.2291 1.64078 19.5022 0.524658L19.4729 1.36175C19.3522 4.81256 16.5571 7.62053 12.9901 7.87483Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.b4bb438b955edf3f5833865d904d8729.svg";
export { ForwardRef as ReactComponent };